import { createReducer, on } from '@ngrx/store';
import { OrderDetailsActions } from '../actions';
import { WholeOrderState } from '../order-details.state';

export const initialState: WholeOrderState = {
  wholeOrderstatus: null,
  success: null,
  loading: null,
  error: null,
};

export const deleteWholeOrderDetailsReducer = createReducer(
  initialState,

  on(OrderDetailsActions.deleteWholeOrderdetails, (state) => {
    return {
      ...state,
      loading: true,
      success: null,
      error: null,
    };
  }),

  on(
    OrderDetailsActions.deleteWholeOrderdetailsSuccess,
    (state, { wholeOrderstatus }) => {
      return {
        ...state,
        wholeOrderstatus,
        success: true,
        loading: null,
        error: null,
      };
    }
  ),

  on(OrderDetailsActions.deleteWholeOrderdetailsFail, (state, { payload }) => {
    return {
      ...state,
      loading: null,
      success: null,
      error: payload,
    };
  })
);
